export function initModal() {
    const body = jQuery('body');
    body.on('click','.newsletter-button', () => {
        jQuery('.newsletter-modal').css('display', 'flex');
    });
    body.on('click', '.modal .back, .modal-close, .continue-shopping',() => {
        jQuery('.modal').css('display', 'none');
    });
}